// extracted by mini-css-extract-plugin
export default {"root":"RawPane_root__YDQbL","pre":"RawPane_pre__tq-yo"};